import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import store from "../../../store";
import { actions } from "../../../store/modules";
import * as types from "../../../store/modules/notification/action-types";
import i18n from "../../../plugins/i18n/i18n";
import moment from "moment";
import { Card, Row, Col, Spin, List, Avatar, Divider, Space, Result, Alert, Button } from 'antd';
import { PullRequestOutlined, CarOutlined, MoneyCollectOutlined, CheckCircleOutlined, ClockCircleOutlined, IssuesCloseOutlined, SwapOutlined, FieldTimeOutlined } from '@ant-design/icons';

const type = "dashboard";

const IconText = ({ icon, text }: { icon: React.FC; text: string }) => (
  <Space>
    {React.createElement(icon)}
    {text}
  </Space>
);


class Home extends Component {
  constructor(props) {
    super(props);
    this.endpoint = { keyOne: type };
    this.endpointApproval = { keyOne: "userservice/approvals" };
    this.endpointNotification = { keyOne: "notification" };

    this.state = {
      startDate: moment(),
      endDate: moment(),
      data: null,
      dataApproval: [],
      dataNotification: [],
      loadings: {
        fetch: true,
        approval: true,
        notification: true
      },
      isVisibleDrawer: false,
      isVisibleDrawerOpen: false,
      selectedType: null,
      selectedItem: null,
      selectedItemId: null
    };
    this.unsubscribe = store.subscribe(() => {
      var type = store.getState().notification.type;

      if (type === types.SET_FETCH_ACCIDENT_NOTIFICATION_TYPE) {
        this.fetchNotification();
      }
    })

  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  componentWillMount() {}

  fetch = () => {

    let { loadings } = this.state;
    loadings.fetch = true;

    this.setState({ loadings })

    var filter = {
      startDate: `${moment(this.state.startDate).format('YYYY-MM-DD')}`,
      endDate: `${moment(this.state.endDate).format('YYYY-MM-DD')}`
    }

    this.props
      .dispatch(
        actions.definitions.getData({
          ...this.endpoint,
          filter: filter,
        })
      )
      .then((response) => {
        loadings.fetch = false;

        this.setState({
          loadings,
          data: response
        });
      });
  };

  fetchApprovals = () => {

    let { loadings } = this.state;
    loadings.approval = true;

    this.setState({ loadings })

    var filter = {
      page: 1,
      pagesize: 100,
      filter: `(approvalStatus~eq~'waitingForApproval')`,
      sort: 'id-desc'
    }

    this.props
      .dispatch(
        actions.definitions.getData({
          ...this.endpointApproval,
          filter: filter,
        })
      )
      .then((response) => {
        loadings.approval = false;

        this.setState({
          loadings,
          dataApproval: response
        });
      });
  };

  fetchNotification = () => {

    let { loadings } = this.state;
    loadings.notification = true;

    this.setState({ loadings })

    var filter = {
      page: 1,
      pagesize: 100,
      filter: `(status~eq~'active')~and~(type~eq~'problem')`,
      sort: 'id-desc'
    }

    this.props
      .dispatch(
        actions.definitions.getData({
          ...this.endpointNotification,
          filter: filter,
        })
      )
      .then((response) => {
        loadings.notification = false;

        this.setState({
          loadings,
          dataNotification: response.data
        });

        this.props.dispatch(actions.notification.delAccidentNotification())

      });
  };


  onChangeDatePicker = (value) => {

    let queryString = "";

    queryString += "?startDate=" + moment(value[0]).format('YYYY-MM-DD');
    queryString += "&endDate=" + moment(value[1]).format('YYYY-MM-DD');

    this.props.history.push({
      pathname: this.props.location.pathname,
      search: queryString,
    });

    this.setState({
      startDate: value[0],
      endDate: value[1]
    }, () => {
      this.fetch();
    })
  }

  onClickRouteTotal = () => {
    this.props.history.push(`routes?statusfilter=all&startDate=${moment(this.state.startDate).format('YYYY-MM-DD')}&endDate=${moment(this.state.endDate).format('YYYY-MM-DD')}`);
  }

  onClickRouteWithoutService = () => {
    this.props.history.push(`routes?statusfilter=planning&startDate=${moment(this.state.startDate).format('YYYY-MM-DD')}&endDate=${moment(this.state.endDate).format('YYYY-MM-DD')}`);
  }

  onClickActiveService = () => {
    this.props.history.push(`services?startDate=${moment(this.state.startDate).format('YYYY-MM-DD')}&endDate=${moment(this.state.endDate).format('YYYY-MM-DD')}`);
  }

  onClickServicePending = () => {
    this.props.history.push(`services?serviceStatus=pending&startDate=${moment(this.state.startDate).format('YYYY-MM-DD')}&endDate=${moment(this.state.endDate).format('YYYY-MM-DD')}`);
  }

  onClickServicePartial = () => {
    this.props.history.push(`services?serviceStatus=partial&startDate=${moment(this.state.startDate).format('YYYY-MM-DD')}&endDate=${moment(this.state.endDate).format('YYYY-MM-DD')}`);
  }

  onClickServiceAssigned = () => {
    this.props.history.push(`services?serviceStatus=assigned&startDate=${moment(this.state.startDate).format('YYYY-MM-DD')}&endDate=${moment(this.state.endDate).format('YYYY-MM-DD')}`);
  }

  onClickProgressPaymentTotal = () => {
    this.props.history.push(`progresspayments/dashboardservices?startDate=${moment(this.state.startDate).format('YYYY-MM-DD')}&endDate=${moment(this.state.endDate).format('YYYY-MM-DD')}`);
  }

  onClickProgressPaymentApproved = () => {
    this.props.history.push(`progresspayments/dashboardservices?status=approved&startDate=${moment(this.state.startDate).format('YYYY-MM-DD')}&endDate=${moment(this.state.endDate).format('YYYY-MM-DD')}`);
  }

  onClickProgressWaitingForCustomerApproval = () => {
    this.props.history.push(`progresspayments/dashboardservices?status=waitingForCustomerApproval&startDate=${moment(this.state.startDate).format('YYYY-MM-DD')}&endDate=${moment(this.state.endDate).format('YYYY-MM-DD')}`);
  }

  onClickProgressWaitingForFailed = () => {
    this.props.history.push(`progresspayments/dashboardservices?status=failed&startDate=${moment(this.state.startDate).format('YYYY-MM-DD')}&endDate=${moment(this.state.endDate).format('YYYY-MM-DD')}`);
  }

  editNotificationItem = (record) => {
    this.setState({ selectedItemId: record.contentId, selectedType: "problem" }, () => {
      this.onChangeDrawerVisible();
    })
  };

  editUserServiceItem = (id) => {
    this.setState({ selectedItemId: id, selectedType: "userService" }, () => {
      this.onChangeDrawerVisible();
    })
  };

  onChangeDrawerVisible = (isRefresh) => {

    let { isVisibleDrawer, isVisibleDrawerOpen, selectedType } = this.state;

    if (isVisibleDrawer) {
      this.setState({ isVisibleDrawer: !isVisibleDrawer }, () => {
        this.setState({ isVisibleDrawerOpen: !isVisibleDrawerOpen });
      })
    } else {
      this.setState({ isVisibleDrawerOpen: !isVisibleDrawerOpen }, () => {
        this.setState({ isVisibleDrawer: !isVisibleDrawer });
      })
    }

    if (isRefresh) {
      if (selectedType === "userService") {
        this.fetchApprovals()
      }
    }
  }

  render() {

    let { loadings, data, dataApproval, dataNotification } = this.state;
    let containerWith = this.props.account.role === "CustomerAdmin" ? 18 : 24;

    return (
      <div className="home">


        {
          loadings.fetch &&
          <div className="ant-loading loading-content">
            <Spin
              tip={`${i18n.t(`loading`, {
                lng: this.props.currentLanguage,
              })}`}
            />
          </div>
        }

        {
          !loadings.fetch &&
          <Fragment>

            {
              this.props.account.role === "CustomerAdmin" && dataNotification.length > 0 &&
              <div className="section">
                <h1>Kaza Bildirimleri</h1>
                <Row gutter={16} style={{ marginTop: 8 }} className="accident-notification">
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    {dataNotification.map((notification, key) => {
                      return (
                        <Alert
                          message={notification.subject}
                          showIcon
                          description={notification.message}
                          type="error"
                          key={key}
                          action={
                            <Fragment>
                              <Button size="small"
                                onClick={() => this.editNotificationItem(notification)}
                                danger>
                                Görüntüle
                              </Button>
                            </Fragment>
                          }
                        />
                      );
                    })}

                    {/* </Card> */}
                  </Col>

                </Row>

              </div>
            }
            <Row gutter={16}>
              <Col xs={24} sm={24} md={24} lg={containerWith} xl={containerWith}>

                <div className="section">
                  <h1>Güzergahlar</h1>
                  <Row gutter={16} style={{ marginTop: 8 }}>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                      <Card onClick={(e) => this.onClickRouteTotal()}>
                        <Row>
                          <Col span={20}>
                            <div className="numbers">
                              <p className="head">Toplam Güzergah Sayısı</p>
                              <h5 className="data">
                                {data.route.total}
                                {/* <span className="percentage">39%</span> */}
                              </h5>
                            </div>

                          </Col>
                          <Col span={4}>
                            <div className="icon-shape color-green">
                              <PullRequestOutlined style={{ fontSize: 40 }} />
                            </div>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                      <Card onClick={(e) => this.onClickRouteTotal()}>
                        <Row>
                          <Col span={20}>
                            <div className="numbers">
                              <p className="head">Sefersiz Güzergah Sayısı</p>
                              <h5 className="data">
                                {data.route.totalWithoutService}
                                <span className="percentage">%{data.route.total !== 0 ? ((100 * data.route.totalWithoutService) / data.route.total).toFixed(2) : (0).toFixed(2)}</span>
                              </h5>
                            </div>

                          </Col>
                          <Col span={4}>
                            <div className="icon-shape color-green">
                              <IssuesCloseOutlined style={{ fontSize: 40 }} />
                            </div>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                      <Card onClick={(e) => this.onClickActiveService()}>
                        <Row>
                          <Col span={20}>
                            <div className="numbers">
                              <p className="head">Aktif Sefer Sayısı</p>
                              <h5 className="data">
                                {data.route.activeService}
                              </h5>
                            </div>

                          </Col>
                          <Col span={4}>
                            <div className="icon-shape color-green">
                              <SwapOutlined style={{ fontSize: 40 }} />
                            </div>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                </div>
                <div className="section">
                  <h1>Araç Atamaları</h1>
                  <Row gutter={16} style={{ marginTop: 8 }}>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                      <Card onClick={(e) => this.onClickServicePending()}>
                        <Row>
                          <Col span={20}>
                            <div className="numbers">
                              <p className="head">Atama Bekleyen</p>
                              <h5 className="data">
                                {data.vehicleAssignment.pending}
                                <span className="percentage">%{data.route.activeService !== 0 ? ((100 * data.vehicleAssignment.pending) / data.route.activeService).toFixed(2) : (0).toFixed(2)}</span>
                              </h5>
                            </div>

                          </Col>
                          <Col span={4}>
                            <div className="icon-shape color-orange">
                              <ClockCircleOutlined style={{ fontSize: 40 }} />
                            </div>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                      <Card onClick={(e) => this.onClickServicePartial()}>
                        <Row>
                          <Col span={20}>
                            <div className="numbers">
                              <p className="head">Kısmi Atama Yapılan</p>
                              <h5 className="data">
                                {data.vehicleAssignment.partial}
                                <span className="percentage">%{data.route.activeService !== 0 ? ((100 * data.vehicleAssignment.partial) / data.route.activeService).toFixed(2) : (0).toFixed(0)}</span>
                              </h5>
                            </div>

                          </Col>
                          <Col span={4}>
                            <div className="icon-shape color-orange">
                              <CarOutlined style={{ fontSize: 40 }} />
                            </div>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                      <Card onClick={(e) => this.onClickServiceAssigned()}>
                        <Row>
                          <Col span={20}>
                            <div className="numbers">
                              <p className="head">Atama Yapılan</p>
                              <h5 className="data">
                                {data.vehicleAssignment.assigned}
                                <span className="percentage">%{data.route.activeService !== 0 ? ((100 * data.vehicleAssignment.assigned) / data.route.activeService).toFixed(2) : (0).toFixed(0)}</span>
                              </h5>
                            </div>

                          </Col>
                          <Col span={4}>
                            <div className="icon-shape color-orange">
                              <CheckCircleOutlined style={{ fontSize: 40 }} />
                            </div>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                </div>
              </Col>

              {this.props.account.role === "CustomerAdmin" &&
                <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                  <div className="section route-approval">
                    <h1 onClick={(e) => this.props.history.push(`userservices`)}>{`Güzergah Onayları ${dataApproval.data && dataApproval.data.length > 0 ? '(' + dataApproval.data.length + ')' : ""}`}</h1>
                    <Divider />
                    <Row gutter={16} style={{ height: 314 }}>
                      <Col span={24}>

                        {
                          dataApproval.data && dataApproval.data.length > 0 ?

                            <List
                              itemLayout="vertical"
                              dataSource={dataApproval.data}
                              loading={loadings.approval}
                              renderItem={item => (
                                <List.Item
                                  onClick={(e) => this.editUserServiceItem(item.id)}
                                  key={item.id}
                                >
                                  <List.Item.Meta
                                    avatar={<Avatar src={item.user.picturePath ? item.user.picturePath : "/assets/img/logo/defaultAvatar.png"} />}
                                    title={item.user.name}
                                  />

                                  <Fragment>
                                    <div className="description">
                                      <IconText icon={PullRequestOutlined} text={item.route.name} key={item.id} />
                                      <IconText icon={FieldTimeOutlined} text={`${i18n.t(item.directionType, { lng: this.props.currentLanguage })} - ${item.service.name}`} key="list-vertical-star-o" />
                                    </div>
                                  </Fragment>

                                </List.Item>
                              )}
                            />

                            :

                            <Result
                              status="success"
                              title="Tebrikler!"
                              subTitle="Tüm güzergahları onayladın."
                            />

                        }



                      </Col>
                    </Row>
                  </div>
                </Col>
              }
            </Row>

            <div className="section">
              <h1>Hakedişler</h1>
              <Row gutter={16} style={{ marginTop: 8 }}>
                <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                  <Card onClick={(e) => this.onClickProgressPaymentTotal()}>
                    <Row>
                      <Col span={20}>
                        <div className="numbers">
                          <p className="head">Toplam</p>
                          <h5 className="data">
                            {data.progressPayment.total}
                          </h5>
                        </div>

                      </Col>
                      <Col span={4}>
                        <div className="icon-shape color-blue">
                          <MoneyCollectOutlined style={{ fontSize: 40 }} />
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                  <Card onClick={(e) => this.onClickProgressPaymentApproved()}>
                    <Row>
                      <Col span={20}>
                        <div className="numbers">
                          <p className="head">Onaylanan</p>
                          <h5 className="data">
                            {data.progressPayment.approved}
                            <span className="percentage">%{data.progressPayment.total !== 0 ? ((100 * data.progressPayment.approved) / data.progressPayment.total).toFixed(2) : (0).toFixed(2)}</span>
                          </h5>
                        </div>

                      </Col>
                      <Col span={4}>
                        <div className="icon-shape color-blue">
                          <CheckCircleOutlined style={{ fontSize: 40 }} />
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                  <Card onClick={(e) => this.onClickProgressWaitingForCustomerApproval()}>
                    <Row>
                      <Col span={20}>
                        <div className="numbers">
                          <p className="head">Onay Bekleyen</p>
                          <h5 className="data">
                            {data.progressPayment.waitingForCustomerApproval}
                            <span className="percentage">%{data.progressPayment.total !== 0 ? ((100 * data.progressPayment.waitingForCustomerApproval) / data.progressPayment.total).toFixed(2) : (0).toFixed(2)}</span>

                          </h5>
                        </div>

                      </Col>
                      <Col span={4}>
                        <div className="icon-shape color-blue">
                          <ClockCircleOutlined style={{ fontSize: 40 }} />
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                  <Card onClick={(e) => this.onClickProgressWaitingForFailed()}>
                    <Row>
                      <Col span={20}>
                        <div className="numbers">
                          <p className="head">Gerçekleşmeyen</p>
                          <h5 className="data">
                            {data.progressPayment.failed}
                            <span className="percentage">%{data.progressPayment.total !== 0 ? ((100 * data.progressPayment.failed) / data.progressPayment.total).toFixed(2) : (0).toFixed(2)}</span>
                          </h5>
                        </div>

                      </Col>
                      <Col span={4}>
                        <div className="icon-shape color-blue">
                          <IssuesCloseOutlined style={{ fontSize: 40 }} />
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>

            </div>
          </Fragment>


        }
      </div>
    )
  }
}

const mapStateToProps = ({ auth }) => ({ ...auth });
export default connect(mapStateToProps)(Home);


// WEBPACK FOOTER //
// ./src/components/App/Views/Home.js